export default {
  musicalGenres: '音乐流派',
  seeMore: '查看更多',
  artists: '艺术家',
  songs: '歌曲',
  topMusicalGenres: '热门音乐流派',
  additionalGenres: '其他流派',
  topArtists: '顶级艺术家',
  additionalArtists: '其他艺术家',
  topSongs: '热门歌曲',
  additionalSongs: '其他歌曲',
  likes: '喜欢',
  peopleLikes: '人们喜欢',
  additionalLikes: '其他赞',
  peoplePerJourneyStatus: '每次旅行人數'
}
